import { IImportCreate } from 'bom/types';
import { partfinitiClient } from 'core/services';

export const createJobImport = (
  data: { bom: number; file: number },
  signal?: AbortSignal
): Promise<IImportCreate> => partfinitiClient.postForm('/bom/import/create', data, { signal });
